import type { CreatePipelineInput, Pipeline, TaskDetail, UpdatePipelineInput } from '@pm/schemas';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

export const pipelineKeys = {
  all: ['pipelines'] as const,
  one: (id: string) => ['pipelines', id] as const,
};

/** Pipelines que eu enxergo (membro, ou todos se tenho pipelines.manage). */
export function usePipelines() {
  return useQuery({
    queryKey: pipelineKeys.all,
    queryFn: () => api.get<Pipeline[]>('/pipelines'),
    staleTime: 30_000,
  });
}

export function usePipeline(id: string | undefined) {
  return useQuery({
    queryKey: pipelineKeys.one(id ?? ''),
    queryFn: () => api.get<Pipeline>(`/pipelines/${id}`),
    enabled: Boolean(id),
  });
}

export function useSavePipeline() {
  const qc = useQueryClient();
  return useMutation<
    Pipeline,
    Error,
    { id?: string; body: CreatePipelineInput | UpdatePipelineInput }
  >({
    mutationFn: ({ id, body }) =>
      id ? api.patch<Pipeline>(`/pipelines/${id}`, body) : api.post<Pipeline>('/pipelines', body),
    onSuccess: (p) => {
      qc.setQueryData(pipelineKeys.one(p.id), p);
      void qc.invalidateQueries({ queryKey: pipelineKeys.all });
      // Renomear colunas muda o que os cartões mostram.
      void qc.invalidateQueries({ queryKey: ['tasks'] });
    },
  });
}

export function useArchivePipeline() {
  const qc = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (id) => api.post<void>(`/pipelines/${id}/archive`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: pipelineKeys.all });
      void qc.invalidateQueries({ queryKey: ['tasks'] });
    },
  });
}

/** Move a demanda de coluna; a API decide (e roda a ação de domínio se a categoria mudar). */
export function moveToStage(taskId: string, stageId: string, comment?: string) {
  return api.post<TaskDetail>(`/tasks/${taskId}/pipeline-stage`, {
    stage_id: stageId,
    ...(comment ? { comment } : {}),
  });
}
